import Vue from 'vue';
import VueUniqueId from 'vue-unique-id';

Vue.use(VueUniqueId);
